import { InvoiceUrl } from "@hubcapp/types";
import { useLazyQuery } from "@apollo/react-hooks";

import InstructorInvoiceUrlQuery from "../graph-ql/getInstructorInvoiceUrl.graphql";

const useInstructorInvoiceUrl = () =>
  useLazyQuery<{ invoiceUrl: InvoiceUrl }>(InstructorInvoiceUrlQuery, {
    fetchPolicy: "network-only",
  });

export default useInstructorInvoiceUrl;
